var render = function () {
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('AppSingleSelect', {
    attrs: {
      "options": _vm.eventOptions
    },
    on: {
      "input": _vm.handleSelect
    },
    model: {
      value: _vm.selectedEvent,
      callback: function callback($$v) {
        _vm.selectedEvent = $$v;
      },
      expression: "selectedEvent"
    }
  });
}
var staticRenderFns = []

export { render, staticRenderFns }